export const API_HOST_URL = import.meta.env.APP_API_HOST || 'https://account.streamster.io/api';

export const SERVERS = ['de10', 'mi1', 'mo1'];

export const API_BALANCER_URLS = SERVERS.map(s => `https://${s}.streamster.io:6001`);
export const API_LOGIN_URLS = SERVERS.map(s => `https://${s}.streamster.io:6002/`);

export const ADMIN_TOKEN_USER_ID = 4;
export const ADMIN_TOKEN_USER_LOGIN = 'sadmin_user';
